import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Layout, notification} from 'antd';
import {useScreenshot} from "use-react-screenshot";

import classes from './Layout.module.scss';
import {setMessage} from '../store/actions';

import SplashScreen from '../components/UI/SplashScreen/SplashScreen';
import Footer from '../components/Navigation/Footer/Footer';
import Sidebar from '../components/Navigation/Sidebar/Sidebar'
import NavigationHeader from '../components/Navigation/NavigationHeader/NavigationHeader';
import ScrollButton from '../components/UI/ScrollUpButton/ScrollUpButton';
import ErrorBoundary from '../components/UI/ErrorBoundary/ErrorBoundary';

const {Content} = Layout;

const MainLayout = (props) => {
    const [mobileSidebarState, setMobileSidebarState] = useState(false);
    const [loadingImage, setLoadingImage] = useState(false);
    const [loading, setLoading] = useState(false);
    const [notificationBox, setNotificationBox] = useState(null);

    const dispatch = useDispatch();
    const message = useSelector(state => state.message.message);
    const ifServerUnavailable = useSelector(state => state.general.ifServerUnavailable);

    const [image, takeScreenShot] = useScreenshot();

    useEffect(() => {
        if (message) {
            setNotificationBox(
                notification[message.type]({
                    message: <b>Внимание!</b>,
                    description: message.text,
                    placement: 'bottomRight',
                    onClose: () => dispatch(setMessage(null))
                }));
        }
    }, [message, dispatch]);

    const getImage = () => {
        if (props.location && props.location.pathname !== '/') {
            setLoading(true);
            takeScreenShot(document.body).then(() => {
                setLoadingImage(true);
                setLoading(false)
            });
        } else {
            setLoadingImage(true);
        }
    }

    useEffect(() => {
        if (loadingImage && !loading) {
            setLoadingImage(false);
            props.history.push({
                pathname: '/support',
                state: {image: image, prevPath: props.location.pathname, bugReportButtonPressed: true}
            });
        }
    }, [loadingImage, loading, props.history, props.location.pathname, image]);

    const isSchedulePathname = (pathname) => {
        const indexOfFirstDelimiter = pathname.indexOf('/');
        if (indexOfFirstDelimiter === -1 || pathname.length < 2) return false;

        const indexOfLastDelimiter = Array.from(pathname).findLastIndex((c, index) => {
            return indexOfFirstDelimiter !== index && c === '/';
        });
        const pathBetweenDelimiters = pathname.substring(indexOfFirstDelimiter + 1,
            indexOfLastDelimiter !== -1 ? indexOfLastDelimiter : undefined);
        return pathBetweenDelimiters === 'schedule';
    }

    const getContentClassname = () => {
        const pathname = props.location.pathname;
        if (pathname === '/') {
            return classes.content + ' Layout_content_color';
        } else if (isSchedulePathname(pathname)) {
            return classes.content + ' Layout_contentFilled_color';
        }
        return classes.contentFilled + ' Layout_contentFilled_color';
    }

    return (
        <div className={classes.layoutContainer}>
            {loading
                ? <SplashScreen/>
                : <Layout hasSider>
                    <ErrorBoundary/>
                    <Sidebar {...props} mobileSidebarState={mobileSidebarState}
                             mobileToggleClicked={() => setMobileSidebarState(!mobileSidebarState)}/>
                    <Layout className={classes.container}>
                        <NavigationHeader {...props}
                                          mobileToggleClicked={() => setMobileSidebarState(!mobileSidebarState)}
                                          setLanguage={props.setLanguage} getImage={getImage}/>
                        <Content className={getContentClassname()}>
                            {props.children}
                        </Content>
                        {(!ifServerUnavailable && message && message.text !== '') && notificationBox}
                        {(props.location.pathname !== '/') ? <ScrollButton/> : null}
                        <Footer/>
                    </Layout>
                </Layout>}
        </div>
    )
}

export default withRouter(MainLayout);